/**
 * @file ローディング表示を制御するステート
 *
 * API呼び出し中等の処理待ち状態をトラッキングする。
 * 配列に処理名を追加/削除することで複数の非同期APIを管理し、
 * 配列が空になった時点でローディング表示が非表示になる。
 * useSetLoadingフックと連携して使用される。
 */
import { atom } from 'recoil';

/**
 * ローディング中の処理名を管理する配列を保持するRecoil atom。
 * 配列が空でなければローディングスピナーが表示される。
 */
const loadingState = atom<string[]>({
  key: 'loadingState',
  default: [],
});

export default loadingState;
